var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cover-image-container"},[_c('a',{staticClass:"cover-image",attrs:{"href":_vm.homepage_url,"title":_vm.heading,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.cover_image_url,"alt":_vm.heading}})]),_c('img',{staticClass:"institution-logo",attrs:{"src":_vm.logo_attachment_url,"alt":"","width":"80","height":"80"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }